import type {
  CreateIntegrationsSyncRunParametersInput,
  SyncValidationsParametersInput,
  SyncableStateStatisticsParametersInput,
} from 'generated/resources/graphql'

export type SyncParameters =
  | CreateIntegrationsSyncRunParametersInput[]
  | SyncValidationsParametersInput[]
  | SyncableStateStatisticsParametersInput[]

export type Parameters = Record<string, string>

export const toSyncParameters = (params: Parameters): SyncParameters => {
  return Object.entries(params).map(([key, value]) => ({ key, value }))
}
